export default __webpack_public_path__ + "static/media/Wrap of the Hell Walker.95edc0f9.jpg";